import { createAction } from '@reduxjs/toolkit'

const USER_ACTION = "user/";

export const SetUserData = createAction(`${USER_ACTION}SetUserData` );

